export default __webpack_public_path__ + "static/media/custodyForm.6d001166.png";